<template>
  <b-col :cols="cols" :md="md" :sm="sm" :lg="lg" :xl="xl">
    <div
      class="py-3 h-100 bg-image cta"
      :class="bgClass"
    >
      <b-img v-if="icon" :src="icon" class="icon" />
      <h3 v-if="h3" v-text="h3" />
      <b-button
        v-if="readmore"
        variant="dark"
        size="sm"
        class="px-5 rounded stretched-link text-nowrap"
        :to="readmore"
      >{{ btnText }}</b-button>
    </div>
  </b-col>
</template>

<script>
export default {
  name: "RowContentCTA",
  props: {
    cols: { type: String },
    md: { type: String, default: "" },
    sm: { type: String, default: "" },
    lg: { type: String, default: "" },
    xl: { type: String, default: "" },
    h3: { type: String },

    // instead of URL, pass a key
    bgKey: { type: String, required: true },

    icon: { type: String },
    btnText: { type: String },
    readmore: { type: Object },
  },
  computed: {
    bgClass() {
      return `bg-${this.bgKey}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.bg-image {
  background-size: cover;
}

/* Explicitly whitelisted backgrounds */
.bg-em {
  background-image: url('~@/assets/content/AssaAbloy_guide_eltryckeslas.jpg');
}

.bg-eb {
  background-image: url('~@/assets/content/AssaAbloy_guide_elslutbleck.jpg');
}

.bg-ms {
  background-image: url('~@/assets/content/AssaAbloy_guide_monteringsstolpe.jpg');
}

.bg-ug {
  background-image: url('~@/assets/content/AssaAbloy_guide_utbytesguide.jpg');
}

.cta {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  height: 350px !important;
  padding: 50px !important;
  margin-bottom: 20px;
  text-align: center;
  box-sizing: border-box;
}

.icon {
  width: 70px;
}

h3 {
  margin-bottom: 31px;
  font-weight: 350;
  font-size: 38px;
  color: #ffffff;
}

img {
  margin-bottom: 21px;
}

p {
  margin-bottom: 29px;
}
</style>
